import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  standalone: false,
  selector: 'app-patient-summary-chart',
  templateUrl: './patient-summary-chart.component.html',
  styleUrls: ['./patient-summary-chart.component.scss']
})
export class PatientSummaryChartComponent implements OnInit
{
  @Input() public memberId: number;

  public loading = true;
  public charts: any[] = [];
  public chart: any;
  public visibleIndex = 0;
  public wellBeingsCollapsed = false;

  private chartNameWellBeing = '';

  constructor(private translate: TranslateService,
    private storageService: LocalStorageService)
  {
    if (this.storageService.retrieve('collapsible-section-well-being') === null)
    {
      this.storageService.store('collapsible-section-well-being', true);
    }
  }

  public ngOnInit(): void
  {
    // Get the translation used when file types is invalid
    this.translate.get(['WELL-BEING-SCORES']).subscribe({
      next: (res) =>
      {
        this.chartNameWellBeing = res['WELL-BEING-SCORES'];
        this.loadCharts();
      }
    });
  }

  public next(): void
  {
    this.visibleIndex++;
    if (this.visibleIndex > this.charts.length - 1)
    {
      this.visibleIndex = 0;
    }
    this.chart = this.charts[this.visibleIndex];
  }

  public previous(): void
  {
    this.visibleIndex--;
    if (this.visibleIndex < 0)
    {
      this.visibleIndex = this.charts.length - 1;
    }
    this.chart = this.charts[this.visibleIndex];
  }

  public loadChart(selected: number): void
  {
    this.visibleIndex = selected;
    this.chart = this.charts[this.visibleIndex];
  }

  private loadCharts(): void
  {
    setTimeout(() =>    // Simulating chart fetch
    {
      this.charts = [];
      this.charts.push({ text: this.chartNameWellBeing });
      // this.charts.push({ text: 'Chart 2' });   // Future usage. We can add additional charts and navigation will show.
      this.visibleIndex = this.charts.length > 0 ? 0 : -1;
      this.chart = this.visibleIndex >= 0 ? this.charts[this.visibleIndex] : null;
      this.loading = false;
    }, 500);
  }
}
